import { render, staticRenderFns } from "./AdminAdwBannersEditor.vue?vue&type=template&id=67e3dd5d&scoped=true&"
import script from "./AdminAdwBannersEditor.vue?vue&type=script&lang=js&"
export * from "./AdminAdwBannersEditor.vue?vue&type=script&lang=js&"
import style0 from "./AdminAdwBannersEditor.vue?vue&type=style&index=0&id=67e3dd5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e3dd5d",
  null
  
)

export default component.exports